import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { verify } from '../../../adapters/apis/auth/auth';
import Login from '../login/Login';
import Profile from '../profile/Profile';
import UseAuth from '../../../hooks/UseAuth';     // ← Changed path

function Verify() {
    const [searchParams] = useSearchParams();
    const { auth } = UseAuth();

    const [response, setResponse] = useState({
        message: '',
        class: '',
        modal: ''
    });

    // Debug logs - check these in browser console
    console.log("🔍 Verify - auth object:", auth);

    useEffect(() => {
        const fullUrl = decodeURIComponent(searchParams.get('verify_url') || '');

        verify(fullUrl).then((res) => {
            setResponse({
                message: res?.data?.data?.message || 'تم تفعيل البريد الإلكتروني بنجاح',
                class: 'alert-primary',
                modal: false
            });
        }).catch((err) => {
            let message = 'حدث خطأ أثناء التحقق';
            if (err?.response?.data?.data?.message) {
                message = err.response.data.data.message;
            }
            if(message == 'صلاحية هذا الرابط منتهية'){
                setResponse({
                    message,
                    class: '',
                    modal: true
                });
                console.log('====================================');
                console.log("kokookokookokok");
                console.log('====================================');
            }else{
                setResponse({
                    message,
                    class: 'alert-danger',
                    modal: false
                });
            }
            
        });
    }, [searchParams]);

    const isLoggedIn = Boolean(auth && auth.accessToken && auth.accessToken !== "");

    console.log("🔍 isLoggedIn result:", isLoggedIn);

    if (isLoggedIn) {
        return <Profile response={{ message: response.message, class: response.class, modal: response.modal }} />;
    }

    return <Login response={response} />;
}

export default Verify;